import React, { useState } from 'react';
import classNames from 'classnames';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { EngagementCards } from './engagement-cards';
import { FilterButtons } from './filter-buttons';
import { useFeedCardOrder } from '../../hooks/use-feed-card-order';
import style from './engagement-card.module.less';
import { messages } from './messages';

export const CardFeed = () => {
  const activeCards = useFeedCardOrder();
  const [filteredCards, setFilteredCards] = useState(activeCards);
  return (
    <FlexColumn className={style.cards}>
      <FlexRow className={style['card-header']}>
        <Text className={style['card-title']} textType={TextType.H2} value={messages.engagementTitle} />
      </FlexRow>
      <FlexRow className={style['filter-buttons-container']}>
        <FilterButtons activeCards={activeCards} setFilteredCards={setFilteredCards} />
      </FlexRow>
      <FlexColumn className={classNames(style['card-feed'], style['active-cards'])}>
        <EngagementCards activeCards={filteredCards} />
      </FlexColumn>
    </FlexColumn>
  );
};
